import type { ReactNode } from 'react';

export const symbol_weather_mix: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M465-54.5Q450-69 450-89q0-10 3.5-18.5T464-123l26-24q5-4 10-4t10 4l26 24q7 7 10.5 15.5T550-89q0 20-15 34.5T500-40q-20 0-35-14.5ZM342-123q-8-8-8-17.5t8-17.5l76-76q8-8 17.5-8t17.5 8q8 8 8 17.5t-8 17.5l-77 77q-8 8-17 7.5t-17-8.5Zm267-50-31-31q-5-5-5-11t5-11l31-31q5-5 11-5t11 5l31 31q5 5 5 11t-5 11l-31 31q-5 5-11 5t-11-5Zm-307-31-31 31q-5 5-11 5t-11-5l-31-31q-5-5-5-11t5-11l31-31q5-5 11-5t11 5l31 31q5 5 5 11t-5 11Zm-12-136q-87 0-148.5-61.5T80-550q0-79 56.5-141T277-759q32-56 84.5-88.5T480-880q91 0 152.5 57.5T708-680q79 4 125.5 53.5T880-510q0 70-49.5 120T710-340H290Zm0-60h420q46 0 78-32.5t32-77.5q0-46-32-78t-78-32h-60v-30q0-71-49.5-120.5T480-820q-51 0-93.5 27.5T324-718l-8 18h-28q-62 2-105 45.5T140-550q0 62 44 106t106 44Zm190-210Z"
		/>
	</svg>
);
